// Auto-generated by config/clients/generate-tv-config.js — do not edit

const BRAND_CONFIGS = {
  "hoxxtv": {
    "$schema": "./schema.json",
    "client": "hoxxtv",
    "displayName": "HoxxTV",
    "namespace": "com.hoxxtv.streaming",
    "urlScheme": "hoxxtv",
    "appBrandEnv": "hoxx",
    "aliases": [
      "hoxx"
    ],
    "domain": "hoxxtv.com",
    "contactEmail": "contato@hoxxtv.com",
    "supportEmail": "suporte@hoxxtv.com",
    "legalName": "Hoxx TV LTDA",
    "cnpj": "08.693.522/0001-28",
    "storageKey": "HoxxTV",
    "cdnDomain": "files.hoxxtv.com",
    "siteDomain": "hoxxtv.com",
    "helpFormUrl": "",
    "favicon": "favicon.ico",
    "headerIcon": "/assets/hoxxtv/logo.png",
    "colors": {
      "primary": "#f95e14",
      "secondary": "#f95e14",
      "background": "#0D1B2A"
    },
    "brandColors": {
      "--darkprimary-color": "#222222",
      "--bg-top-color": "#0D1B2A",
      "--primary-color": "#f95e14",
      "--secondary-color": "#f95e14",
      "--accent-color": "#4BB6FB"
    }
  },
  "hoxx": {
    "$schema": "./schema.json",
    "client": "hoxxtv",
    "displayName": "HoxxTV",
    "namespace": "com.hoxxtv.streaming",
    "urlScheme": "hoxxtv",
    "appBrandEnv": "hoxx",
    "aliases": [
      "hoxx"
    ],
    "domain": "hoxxtv.com",
    "contactEmail": "contato@hoxxtv.com",
    "supportEmail": "suporte@hoxxtv.com",
    "legalName": "Hoxx TV LTDA",
    "cnpj": "08.693.522/0001-28",
    "storageKey": "HoxxTV",
    "cdnDomain": "files.hoxxtv.com",
    "siteDomain": "hoxxtv.com",
    "helpFormUrl": "",
    "favicon": "favicon.ico",
    "headerIcon": "/assets/hoxxtv/logo.png",
    "colors": {
      "primary": "#f95e14",
      "secondary": "#f95e14",
      "background": "#0D1B2A"
    },
    "brandColors": {
      "--darkprimary-color": "#222222",
      "--bg-top-color": "#0D1B2A",
      "--primary-color": "#f95e14",
      "--secondary-color": "#f95e14",
      "--accent-color": "#4BB6FB"
    }
  },
  "ngk": {
    "$schema": "./schema.json",
    "client": "ngk",
    "displayName": "NetGospel Kids",
    "namespace": "com.netgospelkids.streaming",
    "urlScheme": "ngk",
    "appBrandEnv": "ngk",
    "aliases": [
      "ngk"
    ],
    "domain": "netgospelkids.com",
    "contactEmail": "contato@netgospelkids.com",
    "supportEmail": "suporte@netgospelkids.com",
    "legalName": "NetGospel Music",
    "storageKey": "NGK",
    "cdnDomain": "files.netgospelkids.com",
    "helpFormUrl": "https://netgospel.movidesk.com/form/6182",
    "favicon": "logo-icon.png",
    "headerIcon": "/assets/ngk/logo-icon.png",
    "colors": {
      "primary": "#00BCD4",
      "secondary": "#7C4DFF",
      "background": "#0D1B2A"
    },
    "brandColors": {
      "--darkprimary-color": "#0D1B2A",
      "--bg-top-color": "#1A2433",
      "--primary-color": "#00BCD4",
      "--secondary-color": "#7C4DFF",
      "--accent-color": "#FFD54F"
    }
  }
} as const;

export default BRAND_CONFIGS;
